<script lang="ts">
  import { createEventDispatcher } from 'svelte';
  import Modal from './Modal.svelte';

  type ConfirmVariant = 'danger' | 'warning' | 'info';

  let {
    open = $bindable(false),
    title = 'Confirm',
    message = '',
    confirmText = 'Confirm',
    cancelText = 'Cancel',
    variant = 'danger',
    onconfirm = () => {},
    oncancel = () => {}
  }: {
    open?: boolean;
    title?: string;
    message?: string;
    confirmText?: string;
    cancelText?: string;
    variant?: ConfirmVariant;
    onconfirm?: () => void;
    oncancel?: () => void;
  } = $props();

  const dispatch = createEventDispatcher<{
    confirm: void;
    cancel: void;
  }>();

  const variantClasses: Record<ConfirmVariant, string> = {
    danger: 'bg-red-600 hover:bg-red-700 text-white',
    warning: 'bg-yellow-600 hover:bg-yellow-700 text-white',
    info: 'bg-accent-primary hover:opacity-90 text-white'
  };

  function handleConfirm() {
    onconfirm();
    dispatch('confirm');
  }

  function handleCancel() {
    oncancel();
    dispatch('cancel');
  }

  function handleClose() {
    handleCancel();
  }
</script>

<Modal {open} onclose={handleClose} size="sm">
  {#snippet children()}
    <p class="text-text-secondary">{message}</p>
  {/snippet}
  {#snippet footer()}
    <div class="flex justify-end space-x-3">
      <button
        onclick={handleCancel}
        class="px-4 py-2 bg-bg-hover text-text-primary border border-border-default rounded hover:bg-bg-selected transition-colors"
      >
        {cancelText}
      </button>
      <button
        onclick={handleConfirm}
        class="{variantClasses[variant]} px-4 py-2 rounded transition-colors"
      >
        {confirmText}
      </button>
    </div>
  {/snippet}
</Modal>
